import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';

import { getCurrentLanguage } from '../core/helpers/utils';
import { generalTranslations } from '../core/helpers/translations';

// constants
import { EventType } from 'src/app/core/constants/events';

// service
import { EventService } from 'src/app/core/service/event.service';
import { CasosService } from './casos.service';
import { Caso } from './casos.model';
import { AuthenticationService } from '../core/service/auth.service';
import { NotificationsService } from '../core/service/notifications.service';

@Component({
  selector: 'app-gestion',
  templateUrl: './gestion.component.html',
  styleUrls: ['./gestion.component.scss']
})
export class GestionComponent implements OnInit {

  constructor(
    private eventService: EventService,
    private casoService: CasosService,
    private route: ActivatedRoute,
    private authService: AuthenticationService,
    private sanitizer: DomSanitizer,
    private notificationsService: NotificationsService) { }

  currentSection: number = 1;
  innerCurrentSection: number = 1;

  // Variable para controlar la vista de partes
  partesView = 'list'; // puede ser 'list', 'detail' o 'new'
  selectedParteId: string | null = null;

  // ID del caso
  id_caso!: string | null;
  caso!: Caso;
  loaded: boolean = false;
  disableOptions: boolean = true;
  nombreCaso: string = '';

  model = {
    nombre: ''
  }

  ngOnInit(): void {
    let currentLanguage: string = getCurrentLanguage();
    const currentTranslations = generalTranslations[currentLanguage].TABLE;

    const id_caso = this.route.snapshot.paramMap.get('id');
    this.id_caso = id_caso;

    if (id_caso) {
      this.casoService.getCaso(id_caso).subscribe(
        (caso) => {
          //console.log("Caso->", caso)
          this.caso = caso;
          this.nombreCaso = caso.numero_expediente;

          this.authService.currentUser().subscribe(user => {
            this.loaded = true;
            if (user?.nivel_acceso) {

              // Si soy admin no deshabilito opciones
              if (user.nivel_acceso == "ADMIN") {
                this.disableOptions = false;
              }
            }
          });

          this.eventService.broadcast(EventType.CHANGE_PAGE_TITLE,
            {
              title: this.nombreCaso,
              breadCrumbItems: [
                { label: "Casos", path: '.', },
                { label: this.nombreCaso, path: '.', active: true }
              ]
            }
          );

          this.eventService.broadcast(EventType.CHANGE_PAGE_TITLE,
            {
              title: this.nombreCaso,
              breadCrumbItems: [{ label: "Casos", path: '.', }, { label: this.nombreCaso, path: '.', active: true }]
            }
          );

        },
        (error) => {
          console.error('Error obteniendo el caso:', error);
        }
      );
    }
  }

  refrescarCaso(): void {
    //console.log("refrescarCaso")
    const id_caso = this.route.snapshot.paramMap.get('id');
    if (id_caso) {
      this.casoService.getCaso(id_caso).subscribe(
        (caso) => {
          this.caso = caso;
          this.nombreCaso = caso.numero_expediente // Si vengo de Info General y he cambiado el nombre del caso, se refresca.
          //console.log("refrescarCaso", caso);
        },
        (error) => {
          console.error('Error obteniendo el caso:', error);
        }
      );
    }
  }


  onChangePartesView(event: string | { view: string; id?: string }) {
    if (typeof event === 'string') {
      this.partesView = event;
    } else {
      this.partesView = event.view;
      if (event.id) {
        this.selectedParteId = event.id;
      }
    }
    this.refrescarCaso();
  }


  onSubmit() {
  }

  onSwitchChange(id_caso: string | null): void {
    if (!id_caso || !this.caso) return;

    const updatedData = {
      numero_expediente: this.caso.numero_expediente, // Mantener el mismo número de expediente
      enviar_email_subida_archivo: !this.caso.enviar_email_subida_archivo // Cambiar el estado del switch
    };

    this.casoService.updateCaso(id_caso, updatedData).subscribe({
      next: () => {
        const updateCasoSuccessMessage: string = $localize`:@@updateCasoSuccessMessage:Notificación modificada correctamente`;
        this.notificationsService.showSuccessNotification(updateCasoSuccessMessage);

        // Actualizar localmente el caso después del éxito
        this.caso.enviar_email_subida_archivo = updatedData.enviar_email_subida_archivo;
      },
      error: (error) => {
        this.notificationsService.showErrorNotification(error);
      }
    });
  }

  onSwitchChangeHitos(id_caso: string | null): void {
    if (!id_caso || !this.caso) return;

    const updatedData = {
      numero_expediente: this.caso.numero_expediente, // Mantener el mismo número de expediente
      enviar_email_hito: !this.caso.enviar_email_hito // Cambiar el estado del switch
    };

    this.casoService.updateCaso(id_caso, updatedData).subscribe({
      next: () => {
        const updateCasoSuccessMessage: string = $localize`:@@updateCasoSuccessMessage:Notificación modificada correctamente`;
        this.notificationsService.showSuccessNotification(updateCasoSuccessMessage);

        // Actualizar localmente el caso después del éxito
        this.caso.enviar_email_hito = updatedData.enviar_email_hito;
      },
      error: (error) => {
        this.notificationsService.showErrorNotification(error);
      }
    });
  }

  isCaseClosed(): boolean {
    const estadosCerrados = ['CERRADO_LAUDO', 'CERRADO_ACUERDO', 'CERRADO_OTROS', 'CERRADO_REENVIO'];
    return estadosCerrados.includes(this.caso.estado ?? '');
  }


}
